import { request } from "../../utils/request";

/** 积分充值套餐 */
export interface PointRechargePackageRespVO {
  /** 套餐ID */
  id: number;
  /** 套餐名称 */
  packageName: string;
  /** 充值金额（元） */
  priceYuan: number;
  /** 基础积分 */
  basePoint: number;
  /** 赠送积分 */
  bonusPoint: number;
  /** 到账总积分(基础+赠送) */
  totalPoint: number;
  /** 状态: 1-启用 0-停用 */
  status: number;
  /** 排序(升序) */
  sort: number;
  /** 备注 */
  remark?: string;
  /** 创建时间 */
  createTime?: string;
  /** 更新时间 */
  updateTime?: string;
}

export interface PageResultPointRechargePackageRespVO {
  list: PointRechargePackageRespVO[];
  total: number;
}

export interface CommonResultPointRechargePackagePage {
  code: number;
  data: PageResultPointRechargePackageRespVO;
  msg: string;
}

export interface GetRechargePackagesParams {
  pageNo: number;
  pageSize: number;
  /** 套餐名称（模糊匹配），可选 */
  packageName?: string;
  /** 状态: 1-启用 0-停用，可选 */
  status?: number;
}

/**
 * GET /points/recharge-package/page — 分页查询充值套餐
 * 接口文档：doc/充值套餐配置.json
 */
export const getRechargePackagesApi = (
  params: GetRechargePackagesParams
): Promise<CommonResultPointRechargePackagePage> =>
  request<CommonResultPointRechargePackagePage>("/points/recharge-package/page", {
    method: "GET",
    params,
  });